const maskMap = {
	add: "plus",
	archive: "archive",
	bell: "bell",
	bookmark: "ribbon",
	close: "cross",
	delete: "trash",
	doc: "paper",
	email: "mail",
	error: "cross",
	example: "marquee-add",
	export: "outbox",
	favorite: "star",
	file: "file",
	folder: "folder",
	help: "help",
	import: "upload",
	lock: "lock",
	menu: "menu",
	"new-file": "file-add",
	"new-folder": "folder-add",
	pending: "repeat",
	person: "loader",
	print: "printer",
	search: "search",
	settings: "cog",
	share: "link",
	success: "check",
};

export const iconsData = Object.keys(maskMap).reduce((acc, key) => ({
	...acc,
	[key.toUpperCase().replace("-","_")]: {
		uppercase: key.toUpperCase().replace("-","_"),
		lowercase: key,
		image: maskMap[key],
	},
}), {});

export default Object.keys(maskMap).map((key) => key.toUpperCase().replace("-","_"));
